<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择文件"
      width="800px">
    <vm-table ref="vmTable" :filter.sync="filter" module="basic" url="pans/public/getMaxFileList">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="文件名称：">
            <el-input v-model.trim="filter.name" placeholder="请输入文件名称" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="name" label="文件名称"/>
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "CustomerSelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        dialogVisible: false,
        filter: {
          name: "",
          status: 30,
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },

      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>
